myElement = document.getElementsByClassName("menu-toggle")[0]
headroom  = new Headroom(myElement,
  offset: 150
  classes:
    notTop: "menu--not-top"
    pinned : "menu--pinned"
    unpinned : "menu--unpinned"
)
headroom.init()

$ ->

  $init   = $('.ul-lvl2.init')
  $active = $('.lvl1.active')

  initSrc = $('.menu-img').attr('src')

  $('.lvl1')
    .on 'mouseenter', (e) ->
      $el = $(this).find('.ul-lvl2')

      $el.addClass('show2')
      $init.addClass('init2') unless $el.hasClass('init')
      $active.addClass('unactive')

      imgSrc = zz_core.wpurl + "/assets/img/menu-#{$(this).data('theme')}.jpg"

      if imgSrc != initSrc
        newImage = new Image()
        newImage.onload = () ->
          $('.menu-img').fadeOut(100, () ->
            $(this).attr('src', imgSrc).fadeIn()
          )

        newImage.src = imgSrc


      $('.modal').css('--zz-modal-bg': "var(#{$(this).data('color')})")

    .on 'mouseleave', (e) ->
      $el = $(this).find('.ul-lvl2')

      $el.removeClass('show2')
      $init.removeClass('init2')
      $active.removeClass('unactive')

      if $('.menu-img').attr('src') != initSrc
        $('.menu-img').fadeOut(100, () ->
          $(this).attr('src', initSrc).fadeIn()
        )

      $('.modal').css('--zz-modal-bg': 'var(--theme-color)')


  if $('.media-slider').length > 0
    $('.media-slider').each (i, e) ->
      $this = $(e)

      $this.slick
        dots: false
        speed: 500
        fade: true
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<div class="media-control media-control-prev"></div>'
        nextArrow: '<div class="media-control media-control-next"></div>'
        appendArrows: $this.next('.media-controls')

  if $('.full-slider').length > 0
    $('.full-slider').each (i, e) ->
      $this = $(e)

      $this.slick
        dots: false
        slidesToShow: 1
        slidesToScroll: 1
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<div class="media-control media-control-prev h-100"></div>'
        nextArrow: '<div class="media-control media-control-next h-100"></div>'
        appendArrows: $this.next('.media-controls')

  if $('.full-slider-v2').length > 0
    $('.full-slider-v2').each (i, e) ->
      $this = $(e)

      $this.slick
        dots: false
        slidesToShow: 1
        slidesToScroll: 1
        autoplay: true
        autoplaySpeed: 3000
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<div class="media-control media-control-prev h-100"></div>'
        nextArrow: '<div class="media-control media-control-next h-100"></div>'
        appendArrows: $this.next('.media-controls')
        responsive: [
          {
            breakpoint: 1300
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 992
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '160px'
            }
          }
          {
            breakpoint: 768
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '80px'
            }
          }
          {
            breakpoint: 576
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '40px'
            }
          }
        ]
  if $('.full-slider-v3').length > 0
    $('.full-slider-v3').each (i, e) ->
      $this = $(e)
      arrowContainerTarget = e.getAttribute("data-arrow-container-target")

      $this.slick
        dots: false
        slidesToShow: 1
        slidesToScroll: 1
        autoplay: true
        autoplaySpeed: 3000
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<button class="me-5 slider-button" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="45" viewBox="0 0 26 45" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M26.0079 4.30821L22.0956 0.395752L-0.00830078 22.5L22.0956 44.6043L26.0079 40.6918L7.81647 22.5L26.0079 4.30821Z"
                              fill="black"/>
                    </svg>
                </button>'
        nextArrow: '<button class="slider-button" type="button" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="45" viewBox="0 0 26 45" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M-0.00793839 40.6918L3.90444 44.6042L26.0083 22.5L3.90444 0.395706L-0.00793839 4.30817L18.1835 22.5L-0.00793839 40.6918Z"
                              fill="black"/>
                    </svg>
                </button>'
        appendArrows: arrowContainerTarget
        responsive: [
          {
            breakpoint: 1300
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 992
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '160px'
            }
          }
          {
            breakpoint: 768
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '80px'
            }
          }
          {
            breakpoint: 576
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '40px'
            }
          }
        ]

  if $('.icecream-slider').length > 0
    $('.icecream-slider').each (i, e) ->
      $this = $(e)

      $this.slick
        infinite: false
        dots: false
        slidesToShow: 4
        slidesToScroll: 1
        swipeToSlide: true
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<div class="media-control media-control-prev"></div>'
        nextArrow: '<div class="media-control media-control-next"></div>'
        appendArrows: $this.closest('.icecream-slider-wrap')
        responsive: [
          {
            breakpoint: 1920
            settings: {
              slidesToShow: 3
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 1300
            settings: {
              slidesToShow: 2
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 768
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '80px'
            }
          }
          {
            breakpoint: 576
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '40px'
            }
          }
        ]

  if $('.icecream-slider-v2').length > 0
    $('.icecream-slider-v2').each (i, e) ->
      $this = $(e)

      $this.slick
        infinite: false
        dots: false
        slidesToShow: 4
        slidesToScroll: 1
        swipeToSlide: true
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<div class="media-control media-control-prev"></div>'
        nextArrow: '<div class="media-control media-control-next"></div>'
        appendArrows: $this.closest('.icecream-slider-wrap')
        responsive: [
          {
            breakpoint: 1920
            settings: {
              slidesToShow: 4
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 1300
            settings: {
              slidesToShow: 2
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 768
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '80px'
            }
          }
          {
            breakpoint: 576
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '40px'
            }
          }
        ]


  if $('.branch-slider').length > 0
    $('.branch-slider').each (i, e) ->
      $this = $(e)

      $this.slick
        infinite: true
        dots: false
        autoplay: true
        autoplaySpeed: 3000
        slidesToShow: 5
        slidesToScroll: 1
        swipeToSlide: true
        cssEase: 'linear'
        dotsClass: 'branch-slider-dots'
        arrows: true
        prevArrow: '<button class="me-5 slider-button" type="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="45" viewBox="0 0 26 45" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M26.0079 4.30821L22.0956 0.395752L-0.00830078 22.5L22.0956 44.6043L26.0079 40.6918L7.81647 22.5L26.0079 4.30821Z"
                              fill="black"/>
                    </svg>
                </button>'
        nextArrow: '<button class="slider-button" type="button" >
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="45" viewBox="0 0 26 45" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M-0.00793839 40.6918L3.90444 44.6042L26.0083 22.5L3.90444 0.395706L-0.00793839 4.30817L18.1835 22.5L-0.00793839 40.6918Z"
                              fill="black"/>
                    </svg>
                </button>'
        customPaging: (slider, i) ->
              """
              <button>
                <div class='default-icon'>
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="3.5" stroke="black"/>
                  </svg>
                </div>
                <div class='active-icon'>
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="4" cy="4" r="3.5" fill="black" stroke="black"/>
                  </svg>
                </div>
              </button>
              """
        appendArrows: "#branch-slider-arrow-container"
        appendDots: "#branch-slider-dots-container"
        responsive: [
          {
            breakpoint: 1920
            settings: {
              slidesToShow: 5
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 1300
            settings: {
              slidesToShow: 4
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 768
            settings: {
              slidesToShow: 2
              slidesToScroll: 1
              centerMode: true
              centerPadding: '80px'
            }
          }
          {
            breakpoint: 576
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '40px'
              dots: true
            }
          }
        ]

  if $('.review-slider').length > 0
    $('.review-slider').each (i, e) ->
      $this = $(e)
      arrowContainerTarget = e.getAttribute("data-arrow-container-target")

      $this.slick
        dots: false
        slidesToShow: 3
        slidesToScroll: 1
        autoplay: true
        autoplaySpeed: 3000
        centerMode: false
        centerPadding: '0'
        cssEase: 'linear'
        useCSS: false
        arrows: true
        prevArrow: '<button class="slider-button slider-button-rounded" type="button">
                    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M38.0078 11.7451L34.549 8.20508L15.0078 28.2051L34.549 48.2051L38.0078 44.6651L21.9254 28.2051L38.0078 11.7451Z" fill="currentColor"/>
                    </svg>
                </button>'
        nextArrow: '<button class="slider-button slider-button-rounded" type="button" >
                    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9922 11.7451L21.451 8.20508L40.9922 28.2051L21.451 48.2051L17.9922 44.6651L34.0746 28.2051L17.9922 11.7451Z" fill="currentColor"/>
                    </svg>
                </button>'
        appendArrows: arrowContainerTarget
        responsive: [
          {
            breakpoint: 3500
            settings: {
              slidesToShow: 3
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 2500
            settings: {
              slidesToShow: 2
              slidesToScroll: 1
            }
          }
          {
            breakpoint: 1800
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: false
              centerPadding: '60px'
            }
          }
          {
            breakpoint: 992
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: true
              centerPadding: '10px'
            }
          }
          {
            breakpoint: 768
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: false
            }
          }
          {
            breakpoint: 576
            settings: {
              slidesToShow: 1
              slidesToScroll: 1
              centerMode: false
              centerPadding: 0
            }
          }
        ]

  if $('.rolls-wrap').length > 0
    $('.rolls-wrap').each (i, e) ->
      $this = $(e)

      $this.slick
        infinite: true
        dots: false
        slidesToShow: 2
        slidesToScroll: 1
        swipeToSlide: true
        cssEase: 'linear'
        useCSS: false
        arrows: false
        vertical: true
        verticalSwiping: true
        responsive: [
          {
            breakpoint: 768
            settings: {
              slidesToShow: 1
            }
          }
        ]

  $('.rolls-control-prev').on 'click', (e) ->
    e.preventDefault()
    $('.rolls-wrap-left').slick('slickPrev')
    $('.rolls-wrap-right').slick('slickNext')

  $('.rolls-control-next').on 'click', (e) ->
    e.preventDefault()
    $('.rolls-wrap-left').slick('slickNext')
    $('.rolls-wrap-right').slick('slickPrev')


  $('.contact-form').ajaxForm
    beforeSubmit: (arr, $form, options) ->

      $('.contact-form').find('.form-control, .btn').prop 'disabled', () ->
        return !$(this).prop('disabled')

      $('.btn').find('.spinner-border').removeClass('d-none')
      $('.btn').find('.btn-text').addClass('d-none')

      grecaptcha.ready(() ->
        grecaptcha.execute('6LefGG0lAAAAALFxtI7biSvt-aAKeWDkWgXkAtmz', {action: 'submit'}).then((token) ->
          recaptchaResponse = document.getElementById('recaptchaResponse')
          recaptchaResponse.value = token
        )
      )

    success: (responseText, statusText, xhr, $form) ->
      $('.contact-form').find('.form-control, .btn').prop 'disabled', () ->
        return !$(this).prop('disabled')

      $('.btn').find('.spinner-border').addClass('d-none')
      $('.btn').find('.btn-text').removeClass('d-none')

      $.notify "#{responseText.responseText}",
        arrowShow: false
        autoHide: true
        position: 'bottom right'
        className: 'success'
        autoHideDelay: 3000


    error: (responseText, statusText, xhr, $form) ->
      $('.contact-form').find('.form-control, .btn').prop 'disabled', () ->
        return !$(this).prop('disabled')

      $('.btn').find('.spinner-border').addClass('d-none')
      $('.btn').find('.btn-text').removeClass('d-none')

      $.notify "#{responseText.responseText}",
        arrowShow: false
        autoHide: true
        position: 'bottom right'
        className: if responseText.responseText == 'Danke!' then 'success' else 'error'
        autoHideDelay: 3000

    url: 'core/contact.php'
    type: 'post'
    dataType: 'json'
    clearForm: true
    resetForm: true

  initMobileOnlySliders()

  $('[data-copyright]').each (i, e) ->
    copyrightText = e.getAttribute('data-copyright')
    relativeContainer = document.createElement('div')
    relativeContainer.classList.add('position-relative')
    relativeContainer.classList.add('h-100')
    relativeContainer.classList.add('w-100')
    e.parentNode.insertBefore(relativeContainer, e)
    relativeContainer.appendChild(e)

    copyrightElement = document.createElement('div');
    copyrightElement.classList.add('copyright-content');
    copyrightElement.textContent = copyrightText
    relativeContainer.appendChild(copyrightElement)

    console.log('copyright found')



initMobileOnlySliders = ->
  if $('.mobile-only-gallery-slider').length > 0 && window.innerWidth < 992
    $('.mobile-only-gallery-slider').each (i, e) ->
      $this = $(e)
      arrowContainerTarget = e.getAttribute("data-arrow-container-target")

      $this.slick
          dots: false
          slidesToShow: 1
          slidesToScroll: 1
          autoplay: true
          autoplaySpeed: 3000
          cssEase: 'linear'
          useCSS: false
          arrows: true
          prevArrow: '<button class="slider-button slider-button-rounded" type="button">
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M38.0078 11.7451L34.549 8.20508L15.0078 28.2051L34.549 48.2051L38.0078 44.6651L21.9254 28.2051L38.0078 11.7451Z" fill="currentColor"/>
                        </svg>
                    </button>'
          nextArrow: '<button class="slider-button slider-button-rounded" type="button" >
                        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.9922 11.7451L21.451 8.20508L40.9922 28.2051L21.451 48.2051L17.9922 44.6651L34.0746 28.2051L17.9922 11.7451Z" fill="currentColor"/>
                        </svg>
                    </button>'
          appendArrows: arrowContainerTarget

